const designRouter = [
  {
    path: 'measure-house',
    name: 'measure-house',
    component: () => import('@/views/wxapp/designer-manager/measureHouse'),
    meta: {
      title: '订单勘测'
    }
  },
  {
    path: 'follow-list',
    name: 'follow-list',
    component: () => import('@/views/wxapp/designer-manager/home/list/followList'),
    meta: {
      title: '跟进用户'
    }
  },
  {
    path: 'follow-list-need',
    name: 'follow-list-need',
    component: () => import('@/views/wxapp/designer-manager/home/list/followListNeed'),
    meta: {
      title: '今日需跟进'
    }
  },
  {
    path: 'follow-list-details',
    name: 'follow-list-details',
    component: () => import('@/views/wxapp/designer-manager/home/list/followListDetails'),
    meta: {
      title: '跟进用户'
    }
  },
  {
    path: 'design',
    name: 'design',
    component: () => import('@/views/wxapp/designer-manager/design'),
    meta: {
      title: '方案设计'
    }
  },
  {
    path: 'waiting-room',
    name: 'waiting-room',
    component: () => import('@/views/wxapp/designer-manager/list/waitingRoom'),
    meta: {
      title: '待勘测'
    }
  },
  {
    path: 'waiting-design',
    name: 'waiting-design',
    component: () => import('@/views/wxapp/designer-manager/list/waitingDesign'),
    meta: {
      title: '待设计'
    }
  },
  {
    path: 'waiting-quoted',
    name: 'waiting-quoted',
    component: () => import('@/views/wxapp/designer-manager/list/waitingQuoted'),
    meta: {
      title: '待报价'
    }
  },
  {
    path: 'waiting-signed',
    name: 'waiting-signed',
    component: () => import('@/views/wxapp/designer-manager/list/waitingSigned'),
    meta: {
      title: '待签约'
    }
  },
  {
    path: 'waiting-collected',
    name: 'waiting-collected',
    component: () => import('@/views/wxapp/designer-manager/list/waitingCollected'),
    meta: {
      title: '待收款'
    }
  },
  {
    path: 'waiting-selected',
    name: 'waiting-selected',
    component: () => import('@/views/wxapp/designer-manager/list/waitingSelected'),
    meta: {
      title: '待选材'
    }
  },
  {
    path: 'waiting-project',
    name: 'waiting-project',
    component: () => import('@/views/wxapp/designer-manager/list/waitingProject'),
    meta: {
      title: '待转工程部'
    }
  },
  {
    path: 'waiting-initiated',
    name: 'waiting-initiated',
    component: () => import('@/views/wxapp/designer-manager/list/waitingInitiated'),
    meta: {
      title: '待交底'
    }
  },
  {
    path: 'chargeback',
    name: 'chargeback',
    component: () => import('@/views/wxapp/designer-manager/list/chargeback'),
    meta: {
      title: '退单'
    }
  },
  {
    path: 'details-list',
    name: 'details-list',
    component: () => import('@/views/wxapp/designer-manager/home/list/list'),
    meta: {
      title: '详情列表'
    }
  },
  {
    path: 'back-list',
    name: 'back-list',
    component: () => import('@/views/wxapp/designer-manager/functionList/index'),
    meta: {
      title: '退款列表'
    }
  },
  {
    path: 'list',
    name: 'list',
    component: () => import('@/views/wxapp/designer-manager/functionList/list/backList'),
    meta: {
      title: '退款列表'
    }
  },
  {
    path: 'listAll',
    name: 'listAll',
    component: () => import('@/views/wxapp/designer-manager/functionList/list/backAllList.vue'),
    meta: {
      title: '退款列表'
    }
  },
  {
    path: 'measureInvite',
    name: 'measureInvite',
    component: () => import('@/views/wxapp/designer-manager/invite/index'),
    meta: {
      title: '勘测邀约'
    }
  },
  {
    path: 'submitSuEngineering',
    name: 'submitSuEngineering',
    component: () => import('@/views/wxapp/designer-manager/list/submitSuEngineering'),
    meta: {
      title: '待提交工程部'
    }
  },
  {
    path: 'submitSuEngineeringDetails',
    name: 'submitSuEngineeringDetails',
    component: () => import('@/views/wxapp/designer-manager/list/confirmPage/submitSuEngineeringDetails'),
    meta: {
      title: '待提交工程部'
    }
  },
  {
    path: 'basicMessage',
    name: 'basicMessage',
    component: () => import('@/views/wxapp/designer-manager/basicMessage'),
    meta: {
      title: '基础信息'
    }
  },
  {
    path: 'measuringRoom',
    name: 'measuringRoom',
    component: () => import('@/views/wxapp/designer-manager/measuringRoom'),
    meta: {
      title: '快速勘测'
    }
  },
  {
    path: 'house',
    name: 'house',
    component: () => import('@/views/wxapp/designer-manager/measuringRoom/house'),
    meta: {
      title: '快速勘测'
    }
  },
  {
    path: 'quickOffer',
    name: 'quickOffer',
    component: () => import('@/views/wxapp/designer-manager/quickOffer'),
    meta: {
      title: '快速报价'
    }
  },
  {
    path: 'orderList',
    name: 'OrderList',
    component: () => import('@/views/wxapp/designer-manager/orderList'),
    meta: {
      title: '列表'
    }
  },
  {
    path: 'my-self-receipt',
    name: 'MyselfReceipt',
    component: () => import('@/views/wxapp/designer-manager/myselfReceipt'),
    meta: {
      title: '我的收款单'
    }
  },
  {
    path: 'receipt-details',
    name: 'ReceiptDetailsDesigner',
    component: () => import('@/views/wxapp/designer-manager/myselfReceipt/details/index'),
    meta: {
      title: '我的收款单'
    }
  },
  {
    path: 'approval',
    name: 'Approval',
    component: () => import('@/views/wxapp/designer-manager/functionList/list/approval.vue'),
    meta: {
      title: '退款审批'
    }
  }
]
export default designRouter
